import Yup from 'utils/validation';

export const campaignCreationSharedJobInformationSchema = Yup.object({
  jobTitle: Yup.string().required('Enter a job title.'),
  employerName: Yup.string().required('Enter an employer name.'),
  location: Yup.string().required('Enter the location of the job. '),
  contractType: Yup.string().required('Enter contract information.'),
  additionalContext: Yup.string().optional()
});

export type CampaignCreationSharedJobInformationFormData = Yup.InferType<
  typeof campaignCreationSharedJobInformationSchema
>;
